module.exports = __webpack_public_path__ + "img/whatsapp.d9f321ae.png";